<template>
<div>
<CDataTable :items="Object.values(promotions)" :fields="fields" hover class="w-100">
    <template #title="{item}">
        <td class="align-middle">
            {{ item.title }}
        </td>
    </template>
    <template #image="{item}">
        <td class="align-middle">
            <img :src="item.image" :alt="item.title" style="max-height: 50px;max-width: 200px">
        </td>
    </template>
    <template #actions="{item}">
        <td class="align-middle text-center">
            <CLink class="px-1" @click="deleteModal(item)">
                <FaIcon icon="trash" class="text-danger" />
            </CLink>
            <CLink :href="item.href" target="_blank">
                <FaIcon icon="link" class="text-primary" />
            </CLink>
        </td>
    </template>
</CDataTable>
<CModal :title="$t('promotion.delete')" color="danger" :show.sync="showModal">
    {{ $t('promotion.are_you_sure_to_remove', { attribute: deleteItem.title }) }}
    <template #footer>
        <CButton @click="showModal = false" color="secondary">
            {{ $t('cancel') }}
        </CButton>
        <CButton @click="deletePromotion" color="danger">
            {{ $t('delete') }}
        </CButton>
    </template>
</CModal>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { promotionService } from '@/services/api'

export default {
    name: 'SetupPromotionsTable',

    data() {
        return {
            showModal: false,
            deleteItem: {}
        }
    },

    computed: {
        ...mapGetters('promotion', [
            'promotions'
        ]),
        fields() {
            return [
                {
                    key: 'title',
                    label: this.$t('promotion.title'),
                    _style: "width: 20%"
                },
                {
                    key: 'image',
                    label: this.$t('promotion.image'),
                    _style: "width: 50%"

                },
                {
                    key: 'actions',
                    label: this.$t('actions'),
                    _style: "width: 10%"
                }
            ]
        }
    },

    methods: {
        fetchPromotion() {
            this.$store.dispatch('promotion/fetch', {
                per_page: 100,
            })
        },
        deleteModal(promotion) {
            this.deleteItem = promotion
            this.showModal = true
        },
        deletePromotion() {
            this.showModal = false
            promotionService.delete(this.deleteItem.id).then(() => this.fetchPromotion())
        },
    }
}
</script>